import React from "react";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";

export const ResumenTotal = (props) => {
    const { ordenesProduccion = [] } = props;

    return (
        <React.Fragment>
            <div
                className="d-flex justify-content-center mt-4 mb-5"
                style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
            >
                <h4 className="align-self-end my-3">
                    Total de kilogramos a producir:{" "}
                    <RenderKilogramo
                        value={ordenesProduccion.reduce(
                            (total, orden) =>
                                total +
                                (orden.kg_a_producir
                                    ? parseFloat(orden.kg_a_producir)
                                    : 0),
                            0,
                        )}
                    />
                </h4>
            </div>
        </React.Fragment>
    );
};
